import { render, staticRenderFns } from "./JapaneseShow.vue?vue&type=template&id=29231b1b&scoped=true"
import script from "./JapaneseShow.vue?vue&type=script&lang=js"
export * from "./JapaneseShow.vue?vue&type=script&lang=js"
import style0 from "./JapaneseShow.vue?vue&type=style&index=0&id=29231b1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29231b1b",
  null
  
)

export default component.exports